export default {
  SET_CARD_LIST(state, payload) {
    state.cardList = payload;
  },
};
